import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './List.css'

const List = ({ list }) => {
    const [user, setUser] = useState([20]);
    // console.log(items);


    useEffect(() => {
        localStorage.setItem('items', JSON.stringify(user));
    }, [user]);

    let total = 0;
    for (const activity of list) {
        // console.log(activity);
        total = total + activity.time;
    }

    const notify = () => toast("Programming Hero!!!", { position: 'top-center' });


    return (
        <div className='list'>

            <div className='user-img'>
                <img src="https://avatars.githubusercontent.com/u/77801795?v=4" alt="" />
                <div>
                    <h4>Md. Hayatulla Bony</h4>
                    <p>Dhaka, Bangladesh</p>
                </div>
            </div>
            <div className='user-info'>
                <div>
                    <h1>75<span>kg</span></h1>
                    <p>Weight</p>
                </div>
                <div>
                    <h1>6.5</h1>
                    <p>Height</p>
                </div>
                <div>
                    <h1>25<span>yrs</span></h1>
                    <p>Age</p>
                </div>
            </div>
            <div >
                <h1>Add A Break</h1>

                <div className='break-info'>
                    <button id='break-1' onClick={() => setUser(20)}>20</button>
                    <button onClick={() => setUser(30)}>30</button>
                    <button onClick={() => setUser(40)}>40</button>
                    <button onClick={() => setUser(50)}>50</button>
                </div>



                <div className='break-time'>
                    {/* <button onClick={() => savedata('breck-1')}><span >10</span></button> */}

                </div>
            </div>


            <div >
                <h1>Exercise Details</h1>

                <div className='exercise-details'>
                    <h5>Exercise time:  {total} <span>seconds</span> </h5>
                    <h5>Break time:  {user} <span>seconds</span></h5>
                </div>

            </div>
            <button className='btn-style' onClick={notify}>Activity Completed</button>
            <ToastContainer />
        </div>
    );
}
    ;

export default List;